import{u as e}from"./useStorageState-fcf24ebe.js";var o=function(o,r,t){var n="undefined"!=typeof window?window.sessionStorage:void 0;return e(o,r,n,t)};export{o as u};
//# sourceMappingURL=useSessionStorageState-cd509de2.js.map
